import { Slot } from '@radix-ui/react-slot'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import { useDeleteGlobalPcSetMutation } from '@/entities/pricing-campaign'
import { Access } from '@/entities/session'

import { ampli } from '@/shared/lib/ampli'
import { queryClient } from '@/shared/lib/query-client'

export const DeleteGlobalPcSet = ({
	children,
	id,
}: {
	children: React.ReactNode
	id: string
}) => {
	const { t } = useTranslation()

	const deleteGlobalPcSetMutation = useDeleteGlobalPcSetMutation({
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['global-pc-sets-list'],
			})
			queryClient.invalidateQueries({
				queryKey: ['pricing-campaigns'],
			})
			queryClient.invalidateQueries({
				queryKey: ['pricing-campaigns-overview'],
			})
		},
	})
	const handleDeleteGlobalSet = () => {
		ampli.globalPcSetActionClicked({
			global_pc_set_action: 'delete',
		})
		toast.promise(deleteGlobalPcSetMutation.mutateAsync(id), {
			loading: t('deleting.proccess'),
			success: t('deleting.success'),
			error: t('deleting.error'),
		})
	}

	return (
		<Access permissions={['DELETE_GLOBAL_PRICING_CAMPAIGNS']}>
			<Slot onClick={handleDeleteGlobalSet}>{children}</Slot>
		</Access>
	)
}
